import React, { useEffect, useState, Suspense, lazy} from "react";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import StyledApp from "./StyledApp";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import Loader from "./components/Loader";
import { CookieSetting } from "cookiesetting-component";

const Welcome = lazy(() => import("./components/Welcome"));
const Featured = lazy(() => import("./components/Featured"));
const Footer = lazy(() => import("./components/Footer"));
const Schedule = lazy(() => import("./components/Schedule"));
const Favorite = lazy(() => import("./components/Favorite"));
const HappySnaps = lazy(() => import("./components/HappySnaps"));
const Navbar = lazy(() => import("./components/Navbar/Navbar"));
const TopQuotes = lazy(() => import("./components/TopQuotes/TopQuotes"));
const FormBox = lazy(() => import("./components/FormBox"));
const AsSeenOnTV = lazy(() => import("./components/AsSeenOnTV"));
const News = lazy(() => import("./components/News/News"));

const Video = lazy(() => import('../src/components/Video/Video.js'));

export function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  
  const initialData = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    hear: "",
    consent: 'Consent Not Given',
    nmls: "",
    relic: "",
    attendanceType: false,
  };
  const appVersion = appversion.version;

  const [data, setData] = useState(initialData);
  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };
 
  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
  <CacheBuster
          currentVersion={appVersion}
          isEnabled={true}
          isVerboseMode={false}
          metaFileDirectory={"."}
        >
    <StyledApp>
      <Suspense fallback={<div />}>
      <Navbar links={links} handleVideo={handleVideo} videoToggle={videoToggle}/>
      </Suspense>
      <Suspense fallback={<div />}>
      <Welcome links={links} data={data} setData={setData} initialData={initialData} />
      </Suspense>
      <Suspense fallback={<div />}>
      <Featured links={links} handleVideo={handleVideo} videoToggle={videoToggle}/>
      </Suspense>
      <Suspense fallback={<div />}>
      <TopQuotes />
      </Suspense>
      <Suspense fallback={<div />}>
      <Favorite handleVideo={handleVideo} videoToggle={videoToggle}/>
      </Suspense>
      <Suspense fallback={<div />}>
      <AsSeenOnTV />
      </Suspense>
      <Suspense fallback={<div />}>
      <News />
      </Suspense>
      <Suspense fallback={<div />}>
      <Schedule />
      </Suspense>
      <Suspense fallback={<div />}>
      <HappySnaps />
      </Suspense>
      <Suspense fallback={<div />}>
      <FormBox />
      </Suspense>
      <Suspense fallback={<div />}>
      <Footer links={links}/>
      </Suspense>
      
      <Suspense fallback={<Loader />}>
        {played && <Video handleVideo={handleVideo} videoToggle={videoToggle} />}
      </Suspense>
    </StyledApp>
    <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
    </CacheBuster>
  );
}

export default App;
